import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  backgroundColor: "#333",
  borderRadius: "24px",
  padding: "4px",
  position: "absolute",
  right: 20,
  top: 20,
  display: "flex",
  alignItems: "center",
  width: "40%", 
  height: "4%",
});

const StyledToggleButton = styled(ToggleButton)({

    color: "#ccc",
    fontSize: '65%',
    fontWeight: "bold",
    border: "none",
    flex: 1,
    zIndex: 2,
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "#222",
    },
});

const Highlight = styled(motion.div)({
  position: "absolute", 
  top: "4px",
  bottom: "4px",
  left: "7px",
  width: "48%",
  borderRadius: "20px",
  backgroundColor: "#E0E0E0",
  zIndex: 1,
});

const RoadmapPlayToggle = ({view, setView}) => {

  const handleChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <StyledToggleButtonGroup
      data-cy='roadmap-playground-toggle'
      value={view}
      exclusive
      onChange={handleChange}
    >
        
      <Highlight
        initial={{ x: 0 }}
        animate={{ x: view === "roadmap" ? 0 : "100%" }} // Moves highlight smoothly
        transition={{ type: "spring", stiffness: 260, damping: 20 }}
      />
      
      <StyledToggleButton value="roadmap">Roadmap</StyledToggleButton>
      <StyledToggleButton value="playground">Playground</StyledToggleButton>
    </StyledToggleButtonGroup>
  );
};

export default RoadmapPlayToggle;